/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/style-encapsulation';
import { TagLabel } from '@zapier/design-system';

const statusVariations = {
  upcoming: 'light',
  premium: 'dark',
  beta: 'blue',
  featured: 'light',
  'early-access': 'light' /** @todo not sure if this is correct? */,
};

type AppStatusTagProps = {
  /**
   * The type of app status.
   */
  status: keyof typeof statusVariations & string;

  /**
   * The size variation of the TagLabel.
   */
  size: 'medium' | 'small';
};

/**
 * A `TagLabel` for different App statuses.
 */
export const AppStatusTag = (props: AppStatusTagProps) => {
  const { status, size } = props;
  return (
    <TagLabel color={statusVariations[status]} size={size}>
      {status}
    </TagLabel>
  );
};
